/**
 * @file
 * Custom JS behaviour for History.
 */

(function ($) {

  Drupal.behaviors.cards = {
    attach: function (context, settings) {

      /*var cards = $('.node-view-mode-teaser.node-news, .node-view-mode-teaser.node-article, .node-view-mode-teaser.node-product');

      if(cards.length > 0) {
        cards.click(function(e) {
          e.preventDefault();
          var $link = $(this).find('.field--name-node-link a');
          var url = $link.attr('href');
          window.location.href = url;
        });
      }*/

    }
  };

})(jQuery);
